module.exports = __webpack_public_path__ + "static/img/LG_H5.1214c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/LG_H5.png
// module id = Zoxm
// module chunks = 34